import { Auth } from '@aws-amplify/auth'

// Helper function to get the JWT token
const getAuthToken = async () => {
  const user = await Auth.currentAuthenticatedUser()
  return user.signInUserSession.idToken.jwtToken
}

// Helper function for API requests
const apiRequest = async (endpoint, method = 'GET', body = null) => {
  const token = await getAuthToken()
  const baseUrl = import.meta.env.VITE_API_URL
  
  const options = {
    method: method,
    headers: {
      'Authorization': token,
      'Content-Type': 'application/json'
    }
  }
  
  if (body) {
    options.body = JSON.stringify(body)
  }
  
  const response = await fetch(`${baseUrl}${endpoint}`, options)
  
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`API error: ${response.status} - ${errorText}`)
  }
  
  return response.json()
}

// Group operations
export const getGroups = async () => {
  return apiRequest('/admin/groups')
}

export const searchGroups = async (name) => {
  return apiRequest(`/admin/groups/search?name=${encodeURIComponent(name)}`)
}

export const createGroup = async (groupData) => {
  return apiRequest('/admin/groups', 'POST', groupData)
}

// User operations
export const getUsers = async () => {
  return apiRequest('/admin/users')
}

export const searchUsers = async (searchType, searchTerm) => {
  return apiRequest(`/admin/users/search?type=${encodeURIComponent(searchType)}&term=${encodeURIComponent(searchTerm)}`)
}

// User-Group mapping operations
export const assignUsersToGroup = async (userIds, groupName) => {
  return apiRequest('/admin/users-groups', 'POST', { userIds, groupName })
}

export const getUserGroups = async (userId) => {
  return apiRequest(`/admin/users/${encodeURIComponent(userId)}/groups`)
} 